import { render, staticRenderFns } from "./CreateRenewal.vue?vue&type=template&id=ca0fb8a2"
import script from "./CreateRenewal.vue?vue&type=script&lang=js"
export * from "./CreateRenewal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports